import * as angular from 'angular';
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {AccountsContextService} from "../../../commons/services/accounts-context.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {BatchDialogService} from "../../../batch/services/batch-dialogs-service.service";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class UploadDeliveriesViewCtrl implements IController {
  schemaDefaultFields: any;
  schemas: any;

  private enableCreateDeliveriesButton: boolean;
  private readonly siteId: any;
  private orders: any;
  private errorOrders: any;
  private warningOrders: any;
  private currentNavItem: any;
  private editingOrder: any;
  private totals: any;
  private selectedIds: any;
  private queryString: any;
  private doUpdate: any;
  private uploadComplete: any;
  public isFieldMappingOpen: boolean;
  public isDisableCreate: boolean;

  /* @ngInject */
  constructor(private deliveriesDialogService: DeliveriesDialogService, private batchDialogService: BatchDialogService, private deliveriesAlertsService: DeliveriesAlertsService,
              private confirmDialogService: ConfirmDialogService, private confirmChangeStateService: ConfirmChangeStateService, private accountsContextService: AccountsContextService, private deliveriesConstants,
              private splitService: SplitService, private $log, private UUIDService, private batchRequestsService: BatchRequestsService, private bringozLoaderService: BringozLoaderService,
              private $q: IQService, private $state) {
    this.siteId = this.splitService.getSiteId();
  }

  $onInit() {
    this.doUpdate = false;
    this.uploadComplete = false;
    this.currentNavItem = 'total';
    this.selectedIds = [];
    this.orders = [];
    this.errorOrders = [];
    this.warningOrders = [];
    this.totals = {};
    this.enableCreateDeliveriesButton = true;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  changeNavItem(item) {
    this.currentNavItem = item;

    this.editingOrder = undefined;
    this.errorOrders = [];
    this.warningOrders = [];
    this.selectedIds = [];

    if (item === 'total') {
      this.orders = this._resetOrders(this.orders, this._getErrorOrders(this.orders), this._getWarningErrors(this.orders));
    }
    if (item === 'errors') {
      this.errorOrders = this._getErrorOrders(this.orders);
    }
    if (item === 'warnings') {
      this.warningOrders = this._getWarningErrors(this.orders);
    }
  }

  onUpload(event) {
    this.accountsContextService.getFavouriteAccount(this.siteId)
      .then((account) => {
        return this.deliveriesDialogService.importDeliveries(event, account, this.schemas);
      })
      .then((orders) => {
        orders = this._setAllOrdersIds(orders);
        this.orders = this.orders.concat(orders);
        if (this.currentNavItem === 'errors') {
          this.errorOrders = this._getErrorOrders(this.orders);
        }
        if (this.currentNavItem === 'warnings') {
          this.warningOrders = this._getWarningErrors(this.orders);
        }
        this.totals = this._getTotals(this.orders);
        this.uploadComplete = true;
        this.confirmChangeStateService.setIsEnabled(true);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to upload file @uploadDeliveriesButton@onUpload', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
  }

  onQueryChange(query) {
    this.queryString = query;
  }

  onSelectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
    this.isDisableCreate = !!this.orders.filter(o => this.selectedIds.includes(o.orderId) && o.errors?.length)?.length;
  }

  onRemoveOrders(ids) {
    this.orders = _.filter(this.orders, (order) => {
      return _.indexOf(ids, order.orderId) === -1;
    });
    this.totals = this._getTotals(this.orders);
    if (!this.orders.length) {
      this.uploadComplete = false;
    }
  }

  onRemoveErrorOrders(ids) {
    this.errorOrders = _.filter(this.errorOrders, (order) => {
      return _.indexOf(ids, order.orderId) === -1
    });
    this.orders = this._resetOrders(this.orders, this.errorOrders, this._getWarningErrors(this.orders));
    this.totals = this._getTotals(this.orders);
    if (!this.orders.length) {
      this.uploadComplete = false;
    }
  }

  onRemoveWarningOrders(ids) {
    this.warningOrders = _.filter(this.warningOrders, (order) => {
      return _.indexOf(ids, order.orderId) === -1
    });
    this.orders = this._resetOrders(this.orders, this._getErrorOrders(this.orders), this.warningOrders);
    this.totals = this._getTotals(this.orders);
    if (!this.orders.length) {
      this.uploadComplete = false;
    }
  }

  onEditOrder(order) {
    this.editingOrder = angular.copy(order);
  }

  onCancelEditing() {
    this.editingOrder = undefined;
  }

  onSaveEditing(editingOrder) {
    if (this.currentNavItem === 'errors') {
      const updatedErrorOrders = this._updateOrder(this.errorOrders, editingOrder);
      this.orders = this._resetOrders(this.orders, updatedErrorOrders, this._getWarningErrors(this.orders));

      this.errorOrders = _.filter(updatedErrorOrders, (order) => {
        return order.orderId !== editingOrder.orderId;
      });
    }
    if (this.currentNavItem === 'warnings') {
      this.warningOrders = this._updateOrder(this.warningOrders, editingOrder);
      this.orders = this._resetOrders(this.orders, this._getErrorOrders(this.orders), this.warningOrders);
    } else {
      this.orders = this._updateOrder(this.orders, editingOrder);
    }
    this.editingOrder = undefined;
    this.totals = this._getTotals(this.orders);
  }

  onMultipleDelete(ids) {
    if (this.currentNavItem === 'errors') {
      this.onRemoveErrorOrders(ids);
    }
    if (this.currentNavItem === 'warnings') {
      this.onRemoveWarningOrders(ids);
    } else {
      this.onRemoveOrders(ids);
    }
    this.selectedIds = [];
  }

  onCancel(event) {
    return this.confirmDialogService.confirm('Cancel Upload', 'Are you sure you want to cancel upload and reset all deliveries?', event)
      .then(() => {
        this.orders = [];
        this.errorOrders = [];
        this.currentNavItem = 'total';

        this.totals = {};
        this.selectedIds = [];
        this.uploadComplete = false;
        this.confirmChangeStateService.reset();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreate(event) {
    this.enableCreateDeliveriesButton = false;
    const orders = _.map(angular.copy(this.orders), (order) => {
      order.confirm = true;
      return order;
    });

    const serverErrorsCount = this._getWarningErrors(orders).length;
    this._confirmCreate(serverErrorsCount, event)
      .then(() => {
        this.bringozLoaderService.on();
        return this.batchRequestsService.createServicesBatch(orders, this.doUpdate);
      })
      .then((batch) => {
        this.bringozLoaderService.off();
        return this.batchDialogService.batchServicesProgress(event, batch);
      })
      .then((errorItems) => {

        // var errorOrders = _.filter(ctrl.orders, function(o) {
        //     return _.includes(errorRowNumbers, o.row)
        // })

        if (!errorItems.length) {
          this.deliveriesAlertsService.uploadSuccess();
          this.confirmChangeStateService.setIsEnabled(false);
          this.$state.go('deliveries.table');
        } else {

          const errorRowNumbers = _.map(errorItems, 'rowNumber');
          let errorOrders = _.chain(this.orders)
            .filter((o) => {
              return _.includes(errorRowNumbers, o.row)
            })
            .map((filteredOrder) => {
              const errorItem = _.find(errorItems, (errorItem) => {
                return filteredOrder.rowNumber === errorItem.rowNumber;
              })
              filteredOrder.mappingErrors = _.get(errorItem, 'mappingErrors', []);
              return filteredOrder;
            })
            .value();

          errorOrders = this._setAllOrdersIds(errorOrders);

          this.orders = errorOrders;
          this.totals = this._getTotals(errorOrders);
          if (this.currentNavItem === 'errors') {
            this.errorOrders = this._getErrorOrders(errorOrders);
          }
          if (this.currentNavItem === 'warnings') {
            this.warningOrders = this._getWarningErrors(errorOrders);
          }
          if (!this.orders.length) {
            this.uploadComplete = false;
          }
          this.confirmChangeStateService.setIsEnabled(true);
        }
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.createDeliveriesError();
          this.$log.error('Failed to create batch @uploadDeliveriesView@onCreate', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
        this.enableCreateDeliveriesButton = true;
      });
  }

  onDownloadExample() {
    const downloadUrl = this.deliveriesConstants.importDeliveriesSampleFileLink;
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = "import-deliveries-example.xls";
    document.body.appendChild(a);
    a.click();
  }

  onCloseFieldMappingPanel() {
    this.isFieldMappingOpen = false;
  }

  onSchemaCreated(schema) {
    // const schemasCopy = angular.copy(this.schemas);
    // schemasCopy.push(schema);
    this.schemas = [...this.schemas, schema];
  }

  onSchemaUpdated(schema) {
    const schemasCopy = angular.copy(this.schemas);
    const schemaIndex = schemasCopy.findIndex(s => s.id === schema.id);
    schemasCopy.splice(schemaIndex, 1, schema);
    this.schemas = schemasCopy;
  }

  onSchemaDeleted(schemaId) {
    const schemasCopy = angular.copy(this.schemas);
    const schemaIndex = schemasCopy.findIndex(s => s.id === schemaId);
    schemasCopy.splice(schemaIndex, 1);
    this.schemas = schemasCopy;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setAllOrdersIds(orders) {
    return _.map(orders, (order) => {
      order.orderId = this.UUIDService.generate();
      return order;
    })
  }

  private _getTotals(orders) {
    const errors = _.reduce(orders, (sum: any, order) => {
      // var errorList = _.filter(_.get(order, 'errors', []), function(error) {
      //     return error.fieldName !== 'server';
      // });
      // return sum + errorList.length;


      // var hasErrors = !_.isEmpty(order.errors);
      return sum + !_.isEmpty(order.errors);


    }, 0);

    const warnings = _.reduce(orders, (sum: any, order) => {
      const warningList = _.filter(_.get(order, 'errors', []), (error) => {
        return error.fieldName === 'server';
      });
      return sum + warningList.length;
    }, 0);
    return {
      total: orders.length,
      errors: errors,
      warnings: warnings
    }
  }

  private _getErrorOrders(orders) {
    return _.filter(orders, (order) => {
      const errorList = _.filter(_.get(order, 'errors', []), (error) => {
        return error.fieldName !== 'server';
      });
      return errorList.length > 0;
    });
  }

  private _getWarningErrors(orders) {
    return _.filter(orders, (order) => {
      return _.filter(_.get(order, 'errors', []), (error) => {
        return error.fieldName === 'server';
      }).length > 0;
    })
  }

  private _updateOrder(orders, editingOrder) {
    return _.map(orders, (order) => {
      if (order.orderId === editingOrder.orderId) {
        return editingOrder;
      }
      return order;
    });
  }

  private _resetOrders(orders, errorOrders, warningOrders) {
    const filteredOrders = _.filter(orders, (order) => {
      return !order.errors || !order.errors.length;
    });
    return _.chain(filteredOrders)
      .concat(errorOrders, warningOrders)
      .uniqWith(_.isEqual)
      .value();
  }

  private _confirmCreate(serverErrorsCount, event) {
    return serverErrorsCount > 0 ?
      this.confirmDialogService.confirm('Unhandled Warning',
        'There are some unhandled warnings, are you sure you want to continue?', event) :
      this.$q.all(undefined);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('uploadDeliveriesView', {
    bindings: {
      schemaDefaultFields: '<?',
      schemas: '<?'
    },
    template: require('./upload-deliveries-view.html').default,
    controller: UploadDeliveriesViewCtrl
  });
